import slugify from 'slugify';

const ID_WITH_SLUG_SEPARATOR = '-';

const sanitizeSlug = (slug: string) => slugify(slug, { lower: true });

export const extractId = (idWithSlug = '') => idWithSlug.split(ID_WITH_SLUG_SEPARATOR)[0] ?? '';
export const extractSlug = (idWithSlug = '') => idWithSlug.split(ID_WITH_SLUG_SEPARATOR)[1] ?? '';

export const createIdWithSlug = (id: string | number, slug: string) => {
	if (!slug) {
		return `${id}`;
	}

	return `${id}${ID_WITH_SLUG_SEPARATOR}${sanitizeSlug(slug)}`;
};

export const formatDynamicTextKey = (textKey: string, textToReplace: string, replacement: string) =>
	textKey.replace(textToReplace, replacement);

export const textKeyIsSet = (textKey?: string) =>
	textKey !== undefined && !textKey.startsWith('??') && !textKey.endsWith('??');
